'use client';

import { UiKitDialogBase } from '@/fo/ui/kit/dialog/base';
import {
  Product,
  ReviewsData,
  ReviewTab,
  UiReviewCatalogBase
} from '@/fo/ui/review/catalog/base';

import { useReviews } from '../hooks/useReviews';

import { styles } from './FeatureReviewCatalogBase.styles';

export interface FeatureReviewCatalogBaseProps {
  product: Product;
  open?: ReviewTab | null;
  onOpenChange: (open: boolean) => void;
  onClose: () => void;
  onActionClick?: (tab: ReviewTab) => void;
  reviewsData: ReviewsData;
}

export function FeatureReviewCatalogBase({
  product,
  open,
  onOpenChange,
  onClose,
  onActionClick,
  reviewsData: initialReviewsData
}: FeatureReviewCatalogBaseProps) {
  const {
    reviewsData,
    reviewsLoading,
    fetchMoreReviews,
    handleFiltersChange,
    showLoadMore
  } = useReviews(product, initialReviewsData);

  const slots = styles();

  const handleLoadMore = (tab: ReviewTab) => {
    if (tab === ReviewTab.Reviews) {
      fetchMoreReviews();
    }
  };

  return (
    <UiKitDialogBase
      title={product.title}
      open={!!open}
      onOpenChange={onOpenChange}
      fullScreen
      className={slots.base()}
      buttonClassName={slots.closeButton()}
    >
      <div className="container">
        {!!open && (
          <UiReviewCatalogBase
            reviewsData={reviewsData}
            product={product}
            onClose={onClose}
            onActionClick={onActionClick}
            onLoadMore={handleLoadMore}
            onFiltersChange={handleFiltersChange}
            isReviewsLoading={reviewsLoading}
            reviewsShowLoadMore={showLoadMore}
            activeTab={open}
          />
        )}
      </div>
    </UiKitDialogBase>
  );
}
